module.exports = __webpack_public_path__ + "static/media/Express3.6cac5a30.png";